import React from "react";
import {makeStyles} from "@mui/styles";
import {
    FormControl,
    InputLabel,
    MenuItem,
    Pagination,
    Select,
    selectClasses,
    styled,
    useMediaQuery
} from "@mui/material";
import PropTypes from "prop-types";


const useStyles = makeStyles((theme) => ({
    pagination: {
        "& .MuiPaginationItem-root": {
            color: "inherit"
        }
    },
}));

export const StyledInput = styled((props) => (
    <Select {...props}/>
))(({theme}) => ({
    [`& .${selectClasses.icon}`]: {
        color: theme.palette.primary.contrastText,
        fontSize: theme.typography.body1.fontSize,
    },
    [`& .${selectClasses.select}`]: {
        color: theme.palette.primary.contrastText,
        fontSize: theme.typography.body2.fontSize,
    },
}));

export default function ViewerPagination(props) {
    const classes = useStyles();
    const {onChange, count, page, ...other} = props;
    const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'));

    const selectPageChange = (event) => {
        onChange(event, event.target.value);
    }

    return (
        <>
            {lgUp && <Pagination
                {...other}
                count={count}
                page={page}
                onChange={onChange}
                classes={{ul: classes.pagination}}
                size="small"
            />
            }
            <FormControl color={"secondary"}>
                <InputLabel
                    id="viewer-pagination-select-label"
                    sx={{color: theme => theme.palette.primary.contrastText}}>
                    Page
                </InputLabel>
                <StyledInput
                    labelId="viewer-pagination-select-label"
                    id="viewer-pagination-select"
                    value={page}
                    label="Page"
                    size="small"
                    onChange={selectPageChange}
                    color="secondary"
                >
                    {Array.from({length: count}, (_, i) => i + 1).map((i) => (
                        <MenuItem key={`viewer-pagination-${i}`} value={i}>{i}</MenuItem>
                    ))}
                </StyledInput>
            </FormControl>
        </>
    );
}

ViewerPagination.propTypes = {
    onChange: PropTypes.func.isRequired,
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
};